import { render } from "./StartAssessmentPage.vue?vue&type=template&id=279cf67e&scoped=true"
import script from "./StartAssessmentPage.vue?vue&type=script&lang=js"
export * from "./StartAssessmentPage.vue?vue&type=script&lang=js"

import "./StartAssessmentPage.vue?vue&type=style&index=0&id=279cf67e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279cf67e"]])

export default __exports__